const filterActionType = {
    SET_FILTER_INPUT:  'SET_FILTER_INPUT',
    SET_LOCAL_FILTER_FIELD_NAMES_AND_VALUES: 'SET_LOCAL_FILTER_FIELD_NAMES_AND_VALUES',
    SET_FILTER_EMPTY: 'SET_FILTER_EMPTY'
}

export default filterActionType;
